import { Board } from '@ih/app/shared/apis/interfaces';

export class SetBoards {
  public static readonly type = '[Project/Board/List] SetBoards';
  constructor(public readonly boards: Board[]) {}
}
